import * as Types from '@/types';

import * as Apollo from '@apollo/client';
import { gql } from '@apollo/client';
import { useLazyQuery } from '@/hooks/use-lazy-query';
import { useWrappedQuery } from '@/hooks/use-wrapped-query';
const defaultOptions = {} as const;

export const SalesPortalAccountDetailMetricsDocument = gql`
  query SalesPortalAccountDetailMetrics(
    $restaurantUUID: uuid!
    $supplierUUID: uuid!
  ) {
    periodSalesAnalytics: getPeriodSalesAnalytics(
      restaurant_id: $restaurantUUID
      supplier_id: $supplierUUID
    ) {
      avg_order_size
      avg_order_size_percent_change
      currency_code
      period_type
      total_orders
      total_orders_percent_change
      total_sales_in_micros
      total_sales_percent_change
    }
  }
`;
export function useSalesPortalAccountDetailMetricsQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.SalesPortalAccountDetailMetricsQuery,
    Types.SalesPortalAccountDetailMetricsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.SalesPortalAccountDetailMetricsQuery,
    Types.SalesPortalAccountDetailMetricsQueryVariables
  >(SalesPortalAccountDetailMetricsDocument, options);
}
export function useSalesPortalAccountDetailMetricsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.SalesPortalAccountDetailMetricsQuery,
    Types.SalesPortalAccountDetailMetricsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.SalesPortalAccountDetailMetricsQuery,
    Types.SalesPortalAccountDetailMetricsQueryVariables
  >(SalesPortalAccountDetailMetricsDocument, options);
}
export type SalesPortalAccountDetailMetricsQueryHookResult = ReturnType<
  typeof useSalesPortalAccountDetailMetricsQuery
>;
export type SalesPortalAccountDetailMetricsLazyQueryHookResult = ReturnType<
  typeof useSalesPortalAccountDetailMetricsLazyQuery
>;
export type SalesPortalAccountDetailMetricsQueryResult = Apollo.QueryResult<
  Types.SalesPortalAccountDetailMetricsQuery,
  Types.SalesPortalAccountDetailMetricsQueryVariables
>;

/**
 * Wrapped version of useGeneratedSalesPortalAccountDetailMetricsQuery using Pepper's useWrappedQuery
 */
export function useGeneratedSalesPortalAccountDetailMetricsQuery(
  options?: Apollo.QueryHookOptions<
    Types.SalesPortalAccountDetailMetricsQuery,
    Types.SalesPortalAccountDetailMetricsQueryVariables
  >,
) {
  return useWrappedQuery<
    Types.SalesPortalAccountDetailMetricsQuery,
    Types.SalesPortalAccountDetailMetricsQueryVariables
  >(SalesPortalAccountDetailMetricsDocument, options);
}

/**
 * Wrapped version of useGeneratedSalesPortalAccountDetailMetricsLazyQuery using Pepper's useLazyQuery
 */
export function useGeneratedSalesPortalAccountDetailMetricsLazyQuery(
  lazyOptions?: Omit<
    Apollo.QueryOptions<Types.SalesPortalAccountDetailMetricsQueryVariables>,
    'query'
  >,
) {
  return useLazyQuery<
    Types.SalesPortalAccountDetailMetricsQuery,
    Types.SalesPortalAccountDetailMetricsQueryVariables
  >(SalesPortalAccountDetailMetricsDocument, lazyOptions);
}
